import { makeFilterString } from "../utils/Helper";
import {
  CartLogsLoading,
  getCartLogsSuccess,
  getCartLogDetailsSuccess,
} from "./Action";

import { reduxRequest } from "common/utils/reduxRequest";

export const getCartLogsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CartLogsLoading,
    loadingType: "list",
    successFunction: getCartLogsSuccess,
    url: `/admin/carts${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getCartLogDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: CartLogsLoading,
    loadingType: "details",
    successFunction: getCartLogDetailsSuccess,
    action: variables?.action,
    url: `/admin/carts/${variables?.cart_id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export * from "./Action";
export * from "./Reducer";
